'use strict';

import PropTypes from 'prop-types';
import CouponSchema from 'ck-core/source/schemas/CouponSchema';

export default PropTypes.instanceOf(CouponSchema);
